import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

// SK
import s0 from '../assets/images/app_screens/app_screen_0.png'
import s1 from '../assets/images/app_screens/app_screen_1.png'
import s2 from '../assets/images/app_screens/app_screen_2.png'
import s3 from '../assets/images/app_screens/app_screen_3.png'
import s4 from '../assets/images/app_screens/app_screen_4.png'
import s5 from '../assets/images/app_screens/app_screen_5.png'
import s6 from '../assets/images/app_screens/app_screen_6.png'
import s7 from '../assets/images/app_screens/app_screen_7.png'
import s8 from '../assets/images/app_screens/app_screen_8.png'
import s9 from '../assets/images/app_screens/app_screen_9.png'
import s10 from '../assets/images/app_screens/app_screen_10.png'
import s11 from '../assets/images/app_screens/app_screen_11.png'
import s12 from '../assets/images/app_screens/app_screen_12.png'
import s13 from '../assets/images/app_screens/app_screen_13.png'
import s14 from '../assets/images/app_screens/app_screen_14.png'
import s15 from '../assets/images/app_screens/app_screen_15.png'
import s16 from '../assets/images/app_screens/app_screen_16.png'
import s17 from '../assets/images/app_screens/app_screen_17.png'

// EN
import s0_en from '../assets/images/app_screens/app_screen_0_en.png'
import s1_en from '../assets/images/app_screens/app_screen_1_en.png'
import s2_en from '../assets/images/app_screens/app_screen_2_en.png'
import s3_en from '../assets/images/app_screens/app_screen_3_en.png'
import s4_en from '../assets/images/app_screens/app_screen_4_en.png'
import s5_en from '../assets/images/app_screens/app_screen_5_en.png'
import s6_en from '../assets/images/app_screens/app_screen_6_en.png'
import s7_en from '../assets/images/app_screens/app_screen_7_en.png'
import s8_en from '../assets/images/app_screens/app_screen_8_en.png'
import s9_en from '../assets/images/app_screens/app_screen_9_en.png'
import s10_en from '../assets/images/app_screens/app_screen_10_en.png'
import s11_en from '../assets/images/app_screens/app_screen_11_en.png'
import s12_en from '../assets/images/app_screens/app_screen_12_en.png'
import s13_en from '../assets/images/app_screens/app_screen_13_en.png'
import s14_en from '../assets/images/app_screens/app_screen_14_en.png'
import s15_en from '../assets/images/app_screens/app_screen_15_en.png'
import s16_en from '../assets/images/app_screens/app_screen_16_en.png'
import s17_en from '../assets/images/app_screens/app_screen_17_en.png'

// CZ
import s0_cz from '../assets/images/app_screens/app_screen_0_cz.png'
import s1_cz from '../assets/images/app_screens/app_screen_1_cz.png'
import s2_cz from '../assets/images/app_screens/app_screen_2_cz.png'
import s3_cz from '../assets/images/app_screens/app_screen_3_cz.png'
import s4_cz from '../assets/images/app_screens/app_screen_4_cz.png'
import s5_cz from '../assets/images/app_screens/app_screen_5_cz.png'
import s6_cz from '../assets/images/app_screens/app_screen_6_cz.png'
import s7_cz from '../assets/images/app_screens/app_screen_7_cz.png'
import s8_cz from '../assets/images/app_screens/app_screen_8_cz.png'
import s9_cz from '../assets/images/app_screens/app_screen_9_cz.png'
import s10_cz from '../assets/images/app_screens/app_screen_10_cz.png'
import s11_cz from '../assets/images/app_screens/app_screen_11_cz.png'
import s12_cz from '../assets/images/app_screens/app_screen_12_cz.png'
import s13_cz from '../assets/images/app_screens/app_screen_13_cz.png'
import s14_cz from '../assets/images/app_screens/app_screen_14_cz.png'
import s15_cz from '../assets/images/app_screens/app_screen_15_cz.png'
import s16_cz from '../assets/images/app_screens/app_screen_16_cz.png'
import s17_cz from '../assets/images/app_screens/app_screen_17_cz.png'

// DE
import s0_de from '../assets/images/app_screens/app_screen_0_de.png'
import s1_de from '../assets/images/app_screens/app_screen_1_de.png'
import s2_de from '../assets/images/app_screens/app_screen_2_de.png'
import s3_de from '../assets/images/app_screens/app_screen_3_de.png'
import s4_de from '../assets/images/app_screens/app_screen_4_de.png'
import s5_de from '../assets/images/app_screens/app_screen_5_de.png'
import s6_de from '../assets/images/app_screens/app_screen_6_de.png'
import s7_de from '../assets/images/app_screens/app_screen_7_de.png'
import s8_de from '../assets/images/app_screens/app_screen_8_de.png'
import s9_de from '../assets/images/app_screens/app_screen_9_de.png'
import s10_de from '../assets/images/app_screens/app_screen_10_de.png'
import s11_de from '../assets/images/app_screens/app_screen_11_de.png'
import s12_de from '../assets/images/app_screens/app_screen_12_de.png'
import s13_de from '../assets/images/app_screens/app_screen_13_de.png'
import s14_de from '../assets/images/app_screens/app_screen_14_de.png'
import s15_de from '../assets/images/app_screens/app_screen_15_de.png'
import s16_de from '../assets/images/app_screens/app_screen_16_de.png'
import s17_de from '../assets/images/app_screens/app_screen_17_de.png'

// ES
import s0_es from '../assets/images/app_screens/app_screen_0_es.png'
import s1_es from '../assets/images/app_screens/app_screen_1_es.png'
import s2_es from '../assets/images/app_screens/app_screen_2_es.png'
import s3_es from '../assets/images/app_screens/app_screen_3_es.png'
import s4_es from '../assets/images/app_screens/app_screen_4_es.png'
import s5_es from '../assets/images/app_screens/app_screen_5_es.png'
import s6_es from '../assets/images/app_screens/app_screen_6_es.png'
import s7_es from '../assets/images/app_screens/app_screen_7_es.png'
import s8_es from '../assets/images/app_screens/app_screen_8_es.png'
import s9_es from '../assets/images/app_screens/app_screen_9_es.png'
import s10_es from '../assets/images/app_screens/app_screen_10_es.png'
import s11_es from '../assets/images/app_screens/app_screen_11_es.png'
import s12_es from '../assets/images/app_screens/app_screen_12_es.png'
import s13_es from '../assets/images/app_screens/app_screen_13_es.png'
import s14_es from '../assets/images/app_screens/app_screen_14_es.png'
import s15_es from '../assets/images/app_screens/app_screen_15_es.png'
import s16_es from '../assets/images/app_screens/app_screen_16_es.png'
import s17_es from '../assets/images/app_screens/app_screen_17_es.png'

// FR
import s0_fr from '../assets/images/app_screens/app_screen_0_fr.png'
import s1_fr from '../assets/images/app_screens/app_screen_1_fr.png'
import s2_fr from '../assets/images/app_screens/app_screen_2_fr.png'
import s3_fr from '../assets/images/app_screens/app_screen_3_fr.png'
import s4_fr from '../assets/images/app_screens/app_screen_4_fr.png'
import s5_fr from '../assets/images/app_screens/app_screen_5_fr.png'
import s6_fr from '../assets/images/app_screens/app_screen_6_fr.png'
import s7_fr from '../assets/images/app_screens/app_screen_7_fr.png'
import s8_fr from '../assets/images/app_screens/app_screen_8_fr.png'
import s9_fr from '../assets/images/app_screens/app_screen_9_fr.png'
import s10_fr from '../assets/images/app_screens/app_screen_10_fr.png'
import s11_fr from '../assets/images/app_screens/app_screen_11_fr.png'
import s12_fr from '../assets/images/app_screens/app_screen_12_fr.png'
import s13_fr from '../assets/images/app_screens/app_screen_13_fr.png'
import s14_fr from '../assets/images/app_screens/app_screen_14_fr.png'
import s15_fr from '../assets/images/app_screens/app_screen_15_fr.png'
import s16_fr from '../assets/images/app_screens/app_screen_16_fr.png'
import s17_fr from '../assets/images/app_screens/app_screen_17_fr.png'

// HU
import s0_hu from '../assets/images/app_screens/app_screen_0_hu.png'
import s1_hu from '../assets/images/app_screens/app_screen_1_hu.png'
import s2_hu from '../assets/images/app_screens/app_screen_2_hu.png'
import s3_hu from '../assets/images/app_screens/app_screen_3_hu.png'
import s4_hu from '../assets/images/app_screens/app_screen_4_hu.png'
import s5_hu from '../assets/images/app_screens/app_screen_5_hu.png'
import s6_hu from '../assets/images/app_screens/app_screen_6_hu.png'
import s7_hu from '../assets/images/app_screens/app_screen_7_hu.png'
import s8_hu from '../assets/images/app_screens/app_screen_8_hu.png'
import s9_hu from '../assets/images/app_screens/app_screen_9_hu.png'
import s10_hu from '../assets/images/app_screens/app_screen_10_hu.png'
import s11_hu from '../assets/images/app_screens/app_screen_11_hu.png'
import s12_hu from '../assets/images/app_screens/app_screen_12_hu.png'
import s13_hu from '../assets/images/app_screens/app_screen_13_hu.png'
import s14_hu from '../assets/images/app_screens/app_screen_14_hu.png'
import s15_hu from '../assets/images/app_screens/app_screen_15_hu.png'
import s16_hu from '../assets/images/app_screens/app_screen_16_hu.png'
import s17_hu from '../assets/images/app_screens/app_screen_17_hu.png'

// PL
import s0_pl from '../assets/images/app_screens/app_screen_0_pl.png'
import s1_pl from '../assets/images/app_screens/app_screen_1_pl.png'
import s2_pl from '../assets/images/app_screens/app_screen_2_pl.png'
import s3_pl from '../assets/images/app_screens/app_screen_3_pl.png'
import s4_pl from '../assets/images/app_screens/app_screen_4_pl.png'
import s5_pl from '../assets/images/app_screens/app_screen_5_pl.png'
import s6_pl from '../assets/images/app_screens/app_screen_6_pl.png'
import s7_pl from '../assets/images/app_screens/app_screen_7_pl.png'
import s8_pl from '../assets/images/app_screens/app_screen_8_pl.png'
import s9_pl from '../assets/images/app_screens/app_screen_9_pl.png'
import s10_pl from '../assets/images/app_screens/app_screen_10_pl.png'
import s11_pl from '../assets/images/app_screens/app_screen_11_pl.png'
import s12_pl from '../assets/images/app_screens/app_screen_12_pl.png'
import s13_pl from '../assets/images/app_screens/app_screen_13_pl.png'
import s14_pl from '../assets/images/app_screens/app_screen_14_pl.png'
import s15_pl from '../assets/images/app_screens/app_screen_15_pl.png'
import s16_pl from '../assets/images/app_screens/app_screen_16_pl.png'
import s17_pl from '../assets/images/app_screens/app_screen_17_pl.png'

// UA
import s0_ua from '../assets/images/app_screens/app_screen_0_ua.png'
import s1_ua from '../assets/images/app_screens/app_screen_1_ua.png'
import s2_ua from '../assets/images/app_screens/app_screen_2_ua.png'
import s3_ua from '../assets/images/app_screens/app_screen_3_ua.png'
import s4_ua from '../assets/images/app_screens/app_screen_4_ua.png'
import s5_ua from '../assets/images/app_screens/app_screen_5_ua.png'
import s6_ua from '../assets/images/app_screens/app_screen_6_ua.png'
import s7_ua from '../assets/images/app_screens/app_screen_7_ua.png'
import s8_ua from '../assets/images/app_screens/app_screen_8_ua.png'
import s9_ua from '../assets/images/app_screens/app_screen_9_ua.png'
import s10_ua from '../assets/images/app_screens/app_screen_10_ua.png'
import s11_ua from '../assets/images/app_screens/app_screen_11_ua.png'
import s12_ua from '../assets/images/app_screens/app_screen_12_ua.png'
import s13_ua from '../assets/images/app_screens/app_screen_13_ua.png'
import s14_ua from '../assets/images/app_screens/app_screen_14_ua.png'
import s15_ua from '../assets/images/app_screens/app_screen_15_ua.png'
import s16_ua from '../assets/images/app_screens/app_screen_16_ua.png'
import s17_ua from '../assets/images/app_screens/app_screen_17_ua.png'

// ET
import s0_et from '../assets/images/app_screens/app_screen_0_et.png'
import s1_et from '../assets/images/app_screens/app_screen_1_et.png'
import s2_et from '../assets/images/app_screens/app_screen_2_et.png'
import s3_et from '../assets/images/app_screens/app_screen_3_et.png'
import s4_et from '../assets/images/app_screens/app_screen_4_et.png'
import s5_et from '../assets/images/app_screens/app_screen_5_et.png'
import s6_et from '../assets/images/app_screens/app_screen_6_et.png'
import s7_et from '../assets/images/app_screens/app_screen_7_et.png'
import s8_et from '../assets/images/app_screens/app_screen_8_et.png'
import s9_et from '../assets/images/app_screens/app_screen_9_et.png'
import s10_et from '../assets/images/app_screens/app_screen_10_et.png'
import s11_et from '../assets/images/app_screens/app_screen_11_et.png'
import s12_et from '../assets/images/app_screens/app_screen_12_et.png'
import s13_et from '../assets/images/app_screens/app_screen_13_et.png'
import s14_et from '../assets/images/app_screens/app_screen_14_et.png'
import s15_et from '../assets/images/app_screens/app_screen_15_et.png'
import s16_et from '../assets/images/app_screens/app_screen_16_et.png'
import s17_et from '../assets/images/app_screens/app_screen_17_et.png'

const imagesSK = [s0, s1, s15, s17, s2, s3, s4, s14, s5, s6, s7, s8, s9, s10, s11, s12, s13, s16]
const imagesEN = [s0_en, s1_en, s15_en, s17_en, s2_en, s3_en, s4_en, s14_en, s5_en, s6_en, s7_en, s8_en, s9_en, s10_en, s11_en, s12_en, s13_en, s16_en]
const imagesCZ = [s0_cz, s1_cz, s15_cz, s17_cz, s2_cz, s3_cz, s4_cz, s14_cz, s5_cz, s6_cz, s7_cz, s8_cz, s9_cz, s10_cz, s11_cz, s12_cz, s13_cz, s16_cz]
const imagesDE = [s0_de, s1_de, s15_de, s17_de, s2_de, s3_de, s4_de, s14_de, s5_de, s6_de, s7_de, s8_de, s9_de, s10_de, s11_de, s12_de, s13_de, s16_de]
const imagesES = [s0_es, s1_es, s15_es, s17_es, s2_es, s3_es, s4_es, s14_es, s5_es, s6_es, s7_es, s8_es, s9_es, s10_es, s11_es, s12_es, s13_es, s16_es]
const imagesFR = [s0_fr, s1_fr, s15_fr, s17_fr, s2_fr, s3_fr, s4_fr, s14_fr, s5_fr, s6_fr, s7_fr, s8_fr, s9_fr, s10_fr, s11_fr, s12_fr, s13_fr, s16_fr]
const imagesHU = [s0_hu, s1_hu, s15_hu, s17_hu, s2_hu, s3_hu, s4_hu, s14_hu, s5_hu, s6_hu, s7_hu, s8_hu, s9_hu, s10_hu, s11_hu, s12_hu, s13_hu, s16_hu]
const imagesPL = [s0_pl, s1_pl, s15_pl, s17_pl, s2_pl, s3_pl, s4_pl, s14_pl, s5_pl, s6_pl, s7_pl, s8_pl, s9_pl, s10_pl, s11_pl, s12_pl, s13_pl, s16_pl]
const imagesUA = [s0_ua, s1_ua, s15_ua, s17_ua, s2_ua, s3_ua, s4_ua, s14_ua, s5_ua, s6_ua, s7_ua, s8_ua, s9_ua, s10_ua, s11_ua, s12_ua, s13_ua, s16_ua]
const imagesET = [s0_et, s1_et, s15_et, s17_et, s2_et, s3_et, s4_et, s14_et, s5_et, s6_et, s7_et, s8_et, s9_et, s10_et, s11_et, s12_et, s13_et, s16_et]

const HeroCarouselCenter = ({ onClick }) => {
  const { t, i18n } = useTranslation()

  const lang = i18n.language ? i18n.language.toLowerCase() : 'en'

  let images = imagesEN

  if (lang.startsWith('sk')) images = imagesSK
  else if (lang.startsWith('en')) images = imagesEN
  else if (lang.startsWith('cz') || lang.startsWith('cs')) images = imagesCZ
  else if (lang.startsWith('de')) images = imagesDE
  else if (lang.startsWith('es')) images = imagesES
  else if (lang.startsWith('fr')) images = imagesFR
  else if (lang.startsWith('hu')) images = imagesHU
  else if (lang.startsWith('pl')) images = imagesPL
  else if (lang.startsWith('ua') || lang.startsWith('uk')) images = imagesUA
  else if (lang.startsWith('et')) images = imagesET

const [active, setActive] = useState(0)
const [stageWidth, setStageWidth] = useState(0)
const [viewport, setViewport] = useState(window.innerWidth)
const isMobile = viewport <= 768 
const supportsHover = window.matchMedia(
  '(hover: hover) and (pointer: fine)'
).matches
  const [isHover, setIsHover] = useState(false)
  const [showHint, setShowHint] = useState(false)
  const [tooltipBlocked, setTooltipBlocked] = useState(false)
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 })

  const stageRef = useRef(null)
  const dragging = useRef(false)
  const startX = useRef(0)
  const wasDragged = useRef(false)

  const count = images.length

  useEffect(() => {
    setActive(0)
  }, [i18n.language])

  useEffect(() => {
    const onResize = () => setViewport(window.innerWidth)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    if (!showHint) return

    const timer = setTimeout(() => {
      setShowHint(false)
      setTooltipBlocked(true)
    }, 8000)

    return () => clearTimeout(timer)
  }, [showHint])

  useEffect(() => {
    const updateSize = () => {
      if (stageRef.current) {
        setStageWidth(stageRef.current.offsetWidth)
      }
    }

    updateSize()
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      if (!dragging.current && !isHover) {
        setActive(prev => (prev + 1) % count)
      }
    }, 5000)

    return () => clearInterval(interval)
  }, [count, isHover])

  const normalizeOffset = (index) => {
    let offset = index - active
    if (offset > count / 2) offset -= count
    if (offset < -count / 2) offset += count
    return offset
  }

  const getStyle = (index) => {
    const offset = normalizeOffset(index)
    const abs = Math.abs(offset)

    const spacingNear = stageWidth * 0.6
    const spacingFar = stageWidth * 0.4

    if (abs > 2) return { transform: 'scale(0.6)', opacity: 0, zIndex: 0 }
    if (offset === 0) return { transform: 'translateX(0px) scale(1)', opacity: 1, zIndex: 3 }

    if (abs === 1) {
      return {
        transform: `translateX(${offset * spacingNear}px) scale(0.9)`,
        opacity: 1,
        zIndex: 2
      }
    }

    return {
      transform: `translateX(${offset * spacingFar}px) scale(0.7)`,
      opacity: 1,
      zIndex: 1
    }
  }

  const onDown = (e) => {
    dragging.current = true
    wasDragged.current = false
    startX.current = e.clientX
  }

const onMove = (e) => {
  if (!dragging.current) return
  const delta = e.clientX - startX.current

  if (Math.abs(delta) > 5) {
    wasDragged.current = true
  }

  if (Math.abs(delta) > stageWidth * 0.2) {
    if (delta > 0) setActive(prev => (prev - 1 + count) % count)
    else setActive(prev => (prev + 1) % count)
    startX.current = e.clientX
  }
}

  const onUp = () => {
    dragging.current = false
  }

  let stageStyle = { ...styles.stage }

  const isMobileLandscape =
    viewport > 768 &&
    viewport <= 950 &&
    window.innerHeight <= 500 &&
    window.innerWidth > window.innerHeight

  if (viewport >= 2560) {
    stageStyle = { ...stageStyle, height: 'min(65vh, 600px)', marginTop: '120px', marginLeft: '1650px' }
  } else if (viewport >= 1920) {
    stageStyle = { ...stageStyle, height: 'min(65vh, 600px)', marginTop: '100px', marginLeft: '1150px' }
  } else if (viewport >= 1366) {
    stageStyle = { ...stageStyle, height: 'min(60vh, 600px)', marginTop: '40px', marginLeft: '890px' }
  } else if (isMobile) {
    stageStyle = {
      ...stageStyle,
      height: 'min(38vh, 260px)',
      marginTop: '6px',
      marginLeft: 0
    }
  } else if (isMobileLandscape) {
    stageStyle = {
      ...stageStyle,
      height: 'min(60vh, 300px)',
      marginTop: '10px',
      marginLeft: 0
    }
  } else {
    stageStyle = { ...stageStyle, height: 'min(60vh, 300px)', marginTop: '10px', marginLeft: '700px' }
  }

  return (
    <div
      style={{
  ...styles.scene,
  ...(isMobile
    ? {
        height: 'min(38vh, 260px)',
        maxWidth: '100%',
        minWidth: 0,
        margin: '0 auto',
        alignItems: 'flex-start'
      }
    : {})
}}
onMouseEnter={() => {
  if (supportsHover && !tooltipBlocked) {
    setShowHint(true)
  }
}}
      onMouseLeave={() => {
        if (!tooltipBlocked) setShowHint(false)
      }}
    >
      <div
        ref={stageRef}
        style={stageStyle}
        onMouseDown={onDown}
        onMouseMove={(e) => {
          setCursorPos({
            x: e.clientX,
            y: e.clientY
          })

          onMove(e)
        }}
        onMouseUp={onUp}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => {
          setIsHover(false)
          onUp()
        }}
      >
        {showHint && supportsHover && (
          <div
            style={{
              position: 'fixed',
              top: cursorPos.y - 50,
              left: cursorPos.x,
              transform: 'translateX(-50%)',
              background: 'rgba(0,0,0,0.85)',
              color: '#E7DFEC',
              padding: '6px 14px 8px 14px',
              borderRadius: 12,
              fontSize: 16,
              whiteSpace: 'nowrap',
              pointerEvents: 'none',
              zIndex: 5000,
              border: '1.5px solid #0A303B',
              boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
display: 'flex',
flexDirection: 'column',
alignItems: 'center',
gap: '6px',
lineHeight: 1
            }}
          >
            <div>{t('CAROUSEL_HOVER_HINT')}</div>
	    <div>{t('CAROUSEL_CLICK_HINT')}</div>
          </div>
        )}

{images.map((src, i) => (
  <div
    key={i}
    style={{ ...styles.card, ...getStyle(i) }}
    onClick={() => {
      if (!wasDragged.current && onClick) {
        onClick()
      }
    }}
  >
    <img src={src} alt="" style={styles.image} draggable={false} />
  </div>
))}
      </div>
    </div>
  )
}

const styles = {
  scene: {
    width: '100%',
    height: 'min(60vh, 700px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  stage: {
    height: 'min(65vh, 700px)',
    aspectRatio: '9 / 16',
    position: 'relative',
    cursor: 'grab',
    transition: 'all 0.4s ease'
  },
  card: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'all 0.3s ease',
    filter: 'drop-shadow(0 35px 50px rgba(0,0,0,0.4))'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '20px'
  }
}

export default HeroCarouselCenter